// Module
var code = "<div id=loading-bar-spinner> <div class=spinner-icon></div> </div> ";
// Exports
module.exports = code;